import { getStyledElement } from "@/helpers";

export const H1 = getStyledElement("h1")({
  styles: () => ({
    fontSize: "30px"
  })
});

export const H2 = getStyledElement("h2")();
